
export class Collapsebox {
	constructor(component_key) {
		this.id = component_key;
		this.name = 'collapsebox';
		this.component = yalwa.v.components[component_key];
		this.$root = jQuery(`.js-${this.id}`);
		
		this.$collapse_el = this.$root.find(`.js-${this.name}_collapse`);
		this.$collapse_body_el = this.$root.find(`.js-${this.name}_collapse_body`);
		this.$show_more_btn = this.$root.find(`.js-${this.name}_showmore_btn`);
		this.$show_more_label = this.$show_more_btn.find(`.js-${this.name}_showmore_text`);
	}
	init() {
		this.$collapse_body_el.slideUp();
		this.$collapse_el.on('click', (e) => this.init_collapse(e));
		this.$show_more_btn.off('click').on('click',(e) =>  this.show_more_states(e));
	}
	init_collapse(e) {
		let $this = jQuery(e.currentTarget);
		let $toggle_body = $this.parent().find(this.$collapse_body_el);
		$this.toggleClass('js-active');
		$toggle_body.slideToggle();;
	}
	show() {
		yalwa.basics.show(this.$root);
	}
	close() {
		yalwa.basics.hide(this.$root);
	}
	collapse_box() {
		//TODO
	}
	
	show_more_states(e) {
		const $this = jQuery(e.currentTarget);
		const label = $this.hasClass('js-active') ? $this.data('label_showmore') : $this.data('label_showless');
		$this.toggleClass('js-active');
		this.$show_more_label.text(label);
		if ($this.hasClass('js-active')) {
			yalwa.basics.bem_modifier(jQuery('.js-collapsebox_states_body'), 'show_in_limit', 'remove');
		} else {
			yalwa.basics.bem_modifier(jQuery('.js-collapsebox_states_body'), 'show_in_limit', 'add');
		}
		
		// const $show_more_body_el = $this.parent().find('.js-collapsebox_states > .js-collapsebox_states_body');
		// $show_more_body_el.slideToggle().toggleClass('js-active');
	}
}